var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"promo-section",class:{ 'gray-light-bg' : _vm.isGray }})}
var staticRenderFns = []

export { render, staticRenderFns }